import { ChildRowIssuerBadge } from './ChildRowIssuerBadge';

export function ChildRowTetherBadge() {
  return <ChildRowIssuerBadge issuerName="Tether" />;
}
